export default (authToken: string): void => localStorage.setItem('authToken', authToken)
